<script>

/**
 * This component has an html property that it listens to and dynamically converts
 * into vue components and renders them. The only caveat is that any custom components
 * in the HTML must be imported or registered.
 */
import Vue from 'vue'
import Keyword from './Keyword'

export default {
  props: ['html'],


    render(createElement) {
    return createElement({
      template: `<div>${this.html}</div>`, // must have a containing wrapper
      components: {
        Keyword,
      },
    })
  },
}
</script>





// WEBPACK FOOTER //
// DynamicRenderer.vue?722ba528